import VueApexCharts from "vue3-apexcharts";

export default defineNuxtPlugin({
  name: "apexcharts",
  parallel: true,
  async setup(app) {
    app.vueApp.use(VueApexCharts as any);
  },
});
